import $ from 'jquery';
import template from '../templates/ccl.hbs';
/*
 '1': '저작자표시',
 '2': '저작자표시,비영리',
 '3': '저작자표시,변경금지',
 '4': '저작자표시,변경허락',
 '5': '저작자표시,비영리,변경금지',
 '6': '저작자표시,비영리,변경허락'

 1. ccl_commercial = "1", ccl_derivative = "A"
 2. ccl_commercial = "0", ccl_derivative = "A"
 3. ccl_commercial = "1", ccl_derivative = "N"
 4. ccl_commercial = "1", ccl_derivative = "S"
 5. ccl_commercial = "0", ccl_derivative = "S"
 6. ccl_commercial = "0", ccl_derivative = "N"
 */

function CclParams(icon_code, desc) {
  this.icon_code = icon_code;
  this.desc = desc;
}

const cclParamMap = {
  '0': {
    'A': [new CclParams('2', '비영리')],
    'S': [new CclParams('2', '비영리'), new CclParams('3', '변경 금지')],
    'N': [new CclParams('2', '비영리'), new CclParams('4', '변경 허락')]
  },
  '1': {
    'N': [new CclParams('3', '변경 금지')],
    'S': [new CclParams('4', '변경 허락')]
  }
};

const tmpl = $.templates(template);

function getCclHtml(itemInfo) {
  const cclc = itemInfo.cclc;
  const ccld = itemInfo.ccld;

  let templateData;
  try {
    templateData = cclParamMap[cclc][ccld] || [];
  } catch (e) {
    templateData = [];
  }

  return tmpl.render({data: templateData});
}

export default getCclHtml;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/utils/getCclHtml.js
 **/